import { call, put, select } from 'redux-saga/effects';
import { setCompare_, getCompareFail_ } from '../../ducks/compareSlice';
import { requestGetCompare } from '../requests/compare';
export const getCompare = (state) => state.compare;

export function* handleGetCompare(action) {
	try {
		const compare = yield select(getCompare);

		if (compare?.compare_id) {
			const response = yield call(requestGetCompare, compare.compare_id);
			const { data } = response;

			yield put(setCompare_({ product: data.records }));
		}
	} catch (error) {
		yield put(
			getCompareFail_({ message: error.message, response: error.response })
		);
	}
}
